<template>
  <div>
    <!-- 标题 -->
    <h2>文件信息管理</h2>
    <!-- 筛选条件 -->
    <el-row :gutter="20" style="margin-bottom: 20px;">
      <!-- 文件类型下拉框 -->
      <el-col :span="6">
        <el-select v-model="filter.type" placeholder="选择文件类型" clearable>
          <el-option value="" label="全部" />
          <el-option value="image" label="图片" />
          <el-option value="video" label="视频" />
        </el-select>
      </el-col>

      <!-- 机构选择下拉框 -->
      <el-col :span="6">
        <el-select v-model="filter.orgId" placeholder="选择机构" clearable>
          <el-option v-for="org in organizations" :key="org.organizationID" :value="org.organizationID" :label="org.orgName" />
        </el-select>
      </el-col>

      <!-- 文件名输入框 -->
      <el-col :span="6">
        <el-input v-model="filter.name" placeholder="请输入文件名" clearable />
      </el-col>

      <!-- 查询和重置按钮 -->
      <el-col :span="6">
        <el-button type="primary" @click="getFiles">查询</el-button>
        <el-button @click="resetFilters">重置</el-button>
      </el-col>
    </el-row>

    <!-- 添加按钮 -->
    <el-row style="margin-bottom: 20px;">
      <el-col :span="24">
        <el-button type="primary" icon="el-icon-plus" @click="showUploadDialog">上传文件</el-button>
      </el-col>
    </el-row>

    <!-- 编辑文件名弹框 -->
    <el-dialog title="编辑文件名" v-model="editDialogVisible">
      <el-form :model="editForm" label-width="100px">
        <el-form-item label="文件名">
          <el-input v-model="editForm.name" placeholder="请输入文件名" size="small" />
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitEdit">确认</el-button>
      </div>
    </el-dialog>

    <!-- 文件信息表格 -->
    <el-table :data="files" border style="width: 100%">
      <el-table-column label="文件展示" width="400"> <!-- 增加宽度 -->
        <template v-slot="{ row }">
          <div v-if="row.type === 'image'" class="file-display">
            <img :src="row.url" alt="图片预览" class="file-image" />
          </div>
          <div v-else-if="row.type === 'video'" class="file-display">
            <video :src="row.url" alt="视频封面" class="file-image" />
          </div>
        </template>
      </el-table-column>

      <!-- 文件名称 -->
      <el-table-column prop="name" label="文件名称" width="200">
        <template v-slot="{ row }">
          <el-input v-model="row.name" size="small" disabled />
        </template>
      </el-table-column>

      <!-- 操作列 -->
      <el-table-column label="操作" width="120">
        <template v-slot="{ row }">
          <el-button type="text" size="small" @click="deleteFile(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页组件 -->
    <el-pagination
        background
        layout="prev, pager, next, sizes, total"
        :current-page="currentPage"
        :page-size="pageSize"
        :total="total"
        @current-change="handlePageChange"
        @size-change="handlePageSizeChange"
    />


    <!-- 上传文件弹框 -->
    <el-dialog title="上传文件" v-model="uploadDialogVisible">
      <el-form :model="uploadForm" label-width="100px">
        <el-form-item label="文件类型">
          <el-radio-group v-model="uploadForm.fileType">
            <el-radio label="image">图片</el-radio>
            <el-radio label="video">视频</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="选择文件">
          <el-upload
              ref="fileUploader"
              :on-change="handleFileChange"
              :before-upload="beforeUpload"
              :file-list="fileList"
              auto-upload="false"
          >
            <el-button type="primary">选择文件</el-button>
          </el-upload>
          <div v-if="selectedFileName" style="margin-top: 20px;">
            <span>已选择文件：</span>
            <b>{{ selectedFileName }}</b>
          </div>
        </el-form-item>

        <el-form-item label="自定义文件名">
          <el-input v-model="uploadForm.customFileName" placeholder="请输入文件名" size="small" />
        </el-form-item>

        <el-form-item label="选择机构">
          <el-select v-model="uploadForm.orgId" placeholder="选择机构" clearable>
            <el-option v-for="org in organizations" :key="org.organizationID" :value="org.organizationID" :label="org.orgName" />
          </el-select>   </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="uploadDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitUpload">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from "@/axios";
import { ElMessage } from "element-plus";

export default {
  data() {
    return {
      total:0,
      editDialogVisible: false,
      editForm: { name: '', id: '', type: '' },
      files: [], // 文件列表
      uploadDialogVisible: false, // 上传弹框显示控制
      uploadForm: {
        fileType: "image", // 默认上传类型为图片
        customFileName: "", // 自定义文件名
        orgId:''
      },
      filter: {
        type: "", // 文件类型 (image, video, 或空)
        name: "", // 文件名称 (模糊搜索)
        orgId: 2, // 机构ID
      },
      currentPage: 1, // 当前页码
      pageSize: 5, // 每页显示数量
      organizations: [], // 机构列表
      fileList: [], // 文件列表
      selectedFileName: "", // 用于显示的文件名
      imageUploadUrl: "http://localhost:999/images/upload1",
      videoUploadUrl: "http://localhost:999/videos/upload1",
    };
  },

  methods: {
    // 打开上传文件弹框
    showUploadDialog() {
      this.uploadDialogVisible = true;
    },

    // 获取机构列表
    getOrganizations() {
      axios.get('/organization/orglist')  // 假设这是你获取机构列表的 API
          .then(response => {
            if(response.data.success)
            this.organizations = response.data.data;
            else {
              ElMessage.error("获取机构列表失败");
            }
          })
          .catch(error => {
            ElMessage.error("获取机构列表失败");
          });
    },

    // 获取文件列表
    getFiles() {
      const params = {
        videoName: this.filter.name,
        organizationId: this.filter.orgId, // 通过机构进行筛选
        page: this.currentPage , // 后端分页从 0 开始
        size: this.pageSize,
      };
      let urls;
      if (this.filter.type === 'image') {
        urls = '/images/search1';
      } else if (this.filter.type === 'video') {
        urls = '/videos/search1';
      } else {
        urls = '/images/search1';
      }
      axios.get(urls, { params })
          .then(response => {
            this.total=response.data.total;
            this.files = response.data.data.map(file => {
              let fileType;
              if (file.name === undefined) {
                fileType = 'video';
              } else {
                fileType = 'image';
              }
              const fileName = fileType === 'video' ? file.videoName : file.name;
              const src = fileType === 'video' ? file.videoPath : file.src;
              return {
                ...file,
                name: fileName,
                type: fileType,
                url: src
              };
            });
          })
          .catch(error => {
            this.$message.error("获取文件列表失败");
          });
    },

    // 重置筛选条件
    resetFilters() {
      this.filter.type = "";
      this.filter.name = "";
      this.filter.orgId = 1;
      this.getFiles();
    },

    // 删除文件
    deleteFile(file) {
      if (file.type === 'image') {
        axios.delete(`/images/delete1/${file.id}`)
            .then(res => {
              if (res.data.success) {
                this.getFiles();
                ElMessage.success("删除成功");
              } else {
                ElMessage.error("删除失败");
              }
            });
      } else if (file.type === 'video') {
        axios.delete(`/videos/delete1/${file.id}`)
            .then(res => {
              if (res.data.success) {
                this.getFiles();
                ElMessage.success("删除成功");
              } else {
                ElMessage.error("删除失败");
              }
            });
      }
    },

    // 处理分页变更
    handlePageChange(page) {
      this.currentPage = page;
      this.getFiles(); // 页码变化重新获取数据
    },

    // 每页数量变化
    handlePageSizeChange(size) {
      this.pageSize = size;
      this.currentPage = 1; // 重置为第一页
      this.getFiles();
    },
    beforeUpload(file) {
      const isImage = this.uploadForm.fileType === "image" && file.type.startsWith("image/");
      const isVideo = this.uploadForm.fileType === "video" && file.type.startsWith("video/");
      const isValid = isImage || isVideo;

      if (!isValid) {
        ElMessage.error("文件类型不符合要求");
        return false;
      }

      const maxSize = this.uploadForm.fileType === "image" ? 10 : 500; // 图片最大10MB，视频最大500MB
      const isLtSize = file.size / 1024 / 1024 < maxSize;
      if (!isLtSize) {
        ElMessage.error(`文件大小不能超过 ${maxSize}MB`);
        return false;
      }

      // 添加到 fileList
      // 获取文件扩展名
      const fileExtension = file.name.split('.').pop(); // 获取文件的扩展名

      // 添加到 fileList 和文件扩展名
      this.fileList = [file];
      this.selectedFileName = file.name;
      this.uploadForm.fileExtension = fileExtension; // 将扩展名保存到上传表单
      return false; // 阻止默认上传行为
    }
,
    handleFileChange(file) {
      this.selectedFileName = file.name;
    }
    ,

    submitUpload() {
      if (!this.uploadForm.customFileName) {
        ElMessage.warning("请填写文件名");
        return;
      }
      if (this.fileList.length === 0) {
        ElMessage.warning("请先选择文件");
        return;
      }
// 获取扩展名
      const fileExtension = this.uploadForm.fileExtension;
      const customFileNameWithExtension = `${this.uploadForm.customFileName}.${fileExtension}`; // 在自定义文件名后添加扩展名

      const formData = new FormData();
      formData.append("file", this.fileList[0]); // 直接获取 fileList 中的文件对象
      formData.append("fileName", customFileNameWithExtension); // 使用带扩展名的自定义文件名
      formData.append("organizationId", 1);
      formData.append("userId", 1);

      // 根据文件类型选择对应的上传 URL
      const uploadUrl = this.uploadForm.fileType === "video" ? this.videoUploadUrl : this.imageUploadUrl;

      axios.post(uploadUrl, formData)
          .then(response => {
            this.uploadDialogVisible = false;
            ElMessage.success("上传成功");
            this.fileList = []; // 清空文件列表
            this.selectedFileName = ""; // 清空文件名
            this.uploadForm.customFileName = ""; // 重置文件名输入
            this.getFiles(); // 重新获取文件列表
          })
          .catch(() => {
            ElMessage.error("上传失败");
          });
    }
,

    // 提交文件名编辑
    submitEdit() {
      axios.post(`/files/edit/${this.editForm.id}`, { name: this.editForm.name })
          .then(res => {
            this.editDialogVisible = false;
            this.getFiles();
          });
    }
  },

  mounted() {
    this.getFiles();
    this.getOrganizations(); // 初始化时获取机构列表
  }
};
</script >

<style scoped>
.file-display {
  text-align: center;
}

.file-image {
  width: 100%; /* 让图片填充容器 */
  height: auto; /* 保持比例 */
  max-width: 300px; /* 最大宽度 300px */
  max-height: 200px; /* 最大高度 200px */
  object-fit: cover; /* 确保图片覆盖 */
}

.file-image video {
  max-width: 100%; /* 最大宽度 100% */
  max-height: 200px; /* 最大高度 200px */
  object-fit: contain; /* 保持视频比例 */
}
</style>